import styled, { css } from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

import { OptionItemStyleProps } from './list.types'

export const ListWrapper = styled.ul`
    position: relative;
    list-style-type: none;
    margin: 0;
    padding: 8px 0;

    &::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        border: none;
        height: 1px;
        width: 100%;
        background-color: ${({ theme }) => theme.colors.primary70};
    }
`

export const Label = styled.span`
    margin-left: 10px;
    pointer-events: none;

    ${getFontStyle('p02Regular')}
`

const activeOptionStyles = css`
    text-decoration: none;
    color: ${({ theme }) => theme.colors.primaryWhite};
    background: ${({ theme }) => theme.colors.primary70};

    ${Label} {
        ${getFontStyle('p02Medium')}
    }
`

export const ListItem = styled.li`
    position: relative;
    margin: 10px;

    .MuiAccordion-root {
        background-color: transparent;
        box-shadow: none;
        min-height: 40px;

        .MuiAccordionSummary-root {
            padding: 0;
            min-height: 40px;
            width: 100%;
            justify-content: flex-start;

            &.Mui-expanded {
                background-color: ${({ theme }) => theme.colors.primary90};
                z-index: 3;
                padding: 0;
                min-height: 40px;
                cursor: default;

                a {
                    > div > div:last-child {
                        transform: rotateZ(-90deg);
                    }
                }
            }
        }

        &.Mui-expanded {
            margin: 0;
        }

        .MuiAccordionDetails-root {
            padding: 0;
        }

        .MuiAccordionSummary-content {
            margin: 0;
        }
    }

    &:has(.Mui-expanded .MuiAccordionSummary-root .active) {
        .MuiAccordionSummary-root .active {
            color: ${({ theme }) => theme.colors.primary30};
            background-color: inherit;

            &:hover {
                ${activeOptionStyles}
            }

            ${Label} {
                ${getFontStyle('p02Regular')}
            }

            div[class*='-icon'] {
                background-color: ${({ theme }) => theme.colors.primary30};
            }
        }
    }

    &:has(.active):not(:has(.Mui-expanded)) {
        .MuiAccordionSummary-root .dds-navbar-list-item__options-item {
            ${activeOptionStyles}
        }
    }
`

export const OptionsItem = styled.div<OptionItemStyleProps>`
    min-height: 40px;
    width: 100%;
    padding: 0 14px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    color: ${({ theme }) => theme.colors.primary30};
    text-decoration: none;
    cursor: pointer;

    ${getFontStyle('p02Regular')}

    :is(a) {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.primary30};
        &:hover,
        &.active {
            ${activeOptionStyles}
        }
    }

    &:hover,
    &.active {
        ${activeOptionStyles}
    }
`
